/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.30",
    versionName: "0.2.0-nightly.2026.4.30",
    versionChannel: "nightly",
    buildDate: "2026-04-30T00:22:59.070Z",
    commitHash: "8a3e7fd0829acf109ee5f30baac8d860c3a50817",
};
